import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/shared/Homepage/Homepage";
import AdminRegisteration from "./pages/auth/AdminRegisteration/AdminRegisteration";
import LoginPage from "./pages/auth/AdminLogin/AdminLogin";
import Dashboard from "./pages/shared/Dashboard/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./components/Toast/ToastProvider";
import SetupWizardPage from "./pages/admin/SetupWizard/SetupWizardPage";
import AccountActivation from "./pages/auth/AccountActivation/AccountActivation";
import VendorActivation from "./pages/auth/VendorActivation/VendorActivation";
import VendorApplicationFormPage from "./pages/public/VendorApplication/VendorApplicationFormPage";
import ManagerActivation from "./pages/auth/ManagerActivation/ManagerActivation";
import ProfilePage from "./pages/shared/Profile/ProfilePage";
import RequestReset from "./pages/auth/AdminLogin/ForgotPassword/requestReset";
import ResetPassword from "./pages/auth/AdminLogin/ForgotPassword/resetPassword";
import ChangePassword from "./pages/shared/Profile/ChangePasswordPage";
import CreateManager from "./pages/admin/Managers/CreateManager/CreateManagerPage";
import ManagersPage from "./pages/admin/Managers/ManagerList/ManagersPage";
import ManagerDetailPage from "./pages/admin/Managers/ManagerDetails/ManagerDetailPage";

import CreateClientPage from "./pages/admin/Clients/CreateClient/CreateClientPage";
import ClientsPage from "./pages/admin/Clients/ClientList/ClientsPage";
import MasterPriceListPage from "./pages/admin/Clients/PriceList/MasterPriceListPage";
import VendorMasterPriceListPage from "./pages/admin/Vendors/PriceList/MasterPriceListPage";
import ClientDetailPage from "./pages/admin/Clients/ClientDetails/ClientDetailPage";
import ClientPoolsPage from "./pages/admin/ClientPools/ClientPoolsPage";
import AddClientPoolPage from "./pages/admin/ClientPools/ClientPoolForm";
import ClientPoolDetailsPage from "./pages/admin/ClientPools/ClientPoolDetailPage";

import ServicesPage from "./pages/admin/SystemValues/Services/ServicePage";
import LanguagePairsPage from "./pages/admin/SystemValues/LanguagePairs/LanguagePairsPage";
import SpecializationPage from "./pages/admin/SystemValues/Specialization/SpecializationPage";
import UnitPage from "./pages/admin/SystemValues/Units/UnitPage";
import CurrencyPage from "./pages/admin/SystemValues/Currency/CurrencyPage";
import PaymentMethodPage from "./pages/admin/SystemValues/PaymentMethods/PaymentMethodPage";
import SystemValuesPage from "./pages/admin/SystemValues/SystemValuesPage";

import CreateVendorPage from "./pages/admin/Vendors/CreateVendor/CreateVendorPage";
import VendorsPage from "./pages/admin/Vendors/VendorList/VendorsPage";
import VendorDetailPage from "./pages/admin/Vendors/VendorDetails/VendorDetailPage";

import MainLayout from "./components/Sidebar/MainLayout";

import ProjectsPage  from "./pages/admin/Projects/ProjectList/ProjectsPage";
import CreateProjectPage from "./pages/admin/Projects/CreateProject/CreateProjectPage";
import ProjectDetailPage from "./pages/admin/Projects/ProjectDetails/ProjectDetailPage";
import CreateFlatRateReceivablePage from "./pages/admin/Projects/ProjectDetails/Finances/CreateFlatRateReceivablePage"
import CreateUnitBasedReceivablePage from "./pages/admin/Projects/ProjectDetails/Finances/UniBasedReceivablePage"
import CreateJobsPage from "./pages/admin/Projects/ProjectDetails/Jobs/CreateJobsPage";
import JobsPage from "./pages/admin/Jobs/JobsPage";
import JobDetailPage from "./pages/admin/Projects/ProjectDetails/Jobs/JobDetails/JobDetailPage"
import ReceivablesPage from "./pages/admin/ClientReceivables/ReceivablesPage";
import ReceivableDetailPage from "./pages/admin/ClientReceivables/ReceivableDetailPage";
import PayablesPage from "./pages/admin/VendorPayables/PayablesPage";
import PayableDetailPage from "./pages/admin/VendorPayables/PayableDetailPage";
import ClientInvoicesPage from "./pages/admin/ClientInvoices/ClientInvoicesPage";
import ClientInvoiceDetailPage from "./pages/admin/ClientInvoices/ClientInvoiceDetailPage";
import ClientPaymentsPage from "./pages/admin/ClientPayments/ClientPaymentsPage";
import ClientPaymentDetailPage from "./pages/admin/ClientPayments/ClientPaymentDetailPage";
import NewPaymentPage from "./pages/admin/Payments/NewPaymentPage";
import AdjustmentsPage from "./pages/admin/Adjustments/AdjustmentsPage";
import WriteOffPage from "./pages/admin/WriteOff/WriteOffPage";

import QuotationsPage from "./pages/admin/Quotations/QuotationList/QuotationsPage";
import CreateQuotationPage from "./pages/admin/Quotations/QuotationForm/CreateQuotationPage";
import EditQuotationPage from "./pages/admin/Quotations/QuotationForm/EditQuotationPage";
import QuotationDetailPage from "./pages/admin/Quotations/QuotationDetails/QuotationDetailPage";
import QuotationReceivablePage from "./pages/admin/Quotations/QuotationDetails/Finances/QuotationReceivablePage";

import EditJobPage from "./pages/admin/Projects/ProjectDetails/Jobs/EditJobPage";
import EditProjectDetails from "./pages/admin/Projects/ProjectDetails/Details/EditProjectDetails"
import EditFlatRateReceivable from "./pages/admin/Projects/ProjectDetails/Finances/EditFlatRateReceivable";
import EditUnitBasedReceivablePage from "./pages/admin/Projects/ProjectDetails/Finances/EditUnitBasedReceivable";

import CreateFlatRatePayablePage from "./pages/admin/Projects/ProjectDetails/Jobs/PayableToVendors/CreateFlatRatePayablePage"
import UnitBasedPayablePage from "./pages/admin/Projects/ProjectDetails/Jobs/PayableToVendors/UniBasedPayablePage"
import EditFlatRatePayable from "./pages/admin/Projects/ProjectDetails/Jobs/PayableToVendors/EditFlatRatePayable";
import EditUnitBasedPayablePage from "./pages/admin/Projects/ProjectDetails/Jobs/PayableToVendors/EditUnitBasedPayable";

import VendorTendersPage from "./pages/vendor/Tenders/VendorTendersPage";
import VendorAgreementPage from "./pages/vendor/Agreement/VendorAgreementPage";
import VendorReceivablesPage from "./pages/vendor/Receivables/VendorReceivablesPage";
import VendorInvoicesPage from "./pages/vendor/Invoices/VendorInvoicesPage";
import AdminVendorInvoicesPage from "./pages/admin/VendorInvoices/AdminVendorInvoicesPage";
import AdminVendorInvoiceDetailPage from "./pages/admin/VendorInvoices/AdminVendorInvoiceDetailPage";
import VendorPaymentsPage from "./pages/vendor/Payments/VendorPaymentsPage";
import VendorPaymentDetailPage from "./pages/vendor/Payments/VendorPaymentDetailPage";
import AdminVendorPaymentsPage from "./pages/admin/VendorPayments/AdminVendorPaymentsPage";
import AdminVendorPaymentDetailPage from "./pages/admin/VendorPayments/AdminVendorPaymentDetailPage";
import VendorJobsPage from "./pages/vendor/Jobs/VendorJobsPage";
import VendorJobDetailPage from "./pages/vendor/Jobs/VendorJobDetailPage";
import VendorReceivableDetailPage from "./pages/vendor/Receivables/VendorReceivableDetailPage";
import VendorInvoiceDetailPage from "./pages/vendor/Invoices/VendorInvoiceDetailPage";

// Vendor manager portal
import ToDosPage from "./pages/vendorManager/ToDos/ToDosPage";
import VendorApplicationsPage from "./pages/vendorManager/Applications/VendorApplicationsPage";
import VendorContactsPage from "./pages/vendorManager/Contacts/VendorContactsPage";
import VendorPricesPage from "./pages/vendorManager/Prices/VendorPricesPage";
import VendorTagsPage from "./pages/vendorManager/Tags/VendorTagsPage";
import SystemValuesServicesPage from "./pages/vendorManager/SystemValues/ServicesPage";
import SystemValuesLanguagePairsPage from "./pages/vendorManager/SystemValues/LanguagePairsPage";
import SystemValuesSpecializationsPage from "./pages/vendorManager/SystemValues/SpecializationsPage";
import PlaceholderPage from "./components/Placeholder/PlaceholderPage";

// Freelance-only modules
import FilesPage from "./pages/admin/Files/FilesPage";
import FinancesPage from "./pages/admin/Finances/FinancesPage";

import SettingsPage from "./pages/admin/Settings/SettingsPage";
import AccountPage from "./pages/admin/Settings/Account/AccountPage";
import ObjectCodesPage from "./pages/admin/Settings/ObjectCodes/ObjectCodesPage";
import RemindersPage from "./pages/admin/Settings/Reminders/RemindersPage";
import VendorPortalPage from "./pages/admin/Settings/VendorPortal/VendorPortalPage";
import SmtpServerPage from "./pages/admin/Settings/SmtpServer/SmtpServerPage";
import TaxesPage from "./pages/admin/Settings/Taxes/TaxesPage";
import DefaultTaxesPage from "./pages/admin/Settings/Taxes/DefaultTaxesPage";

import { ADMIN, ADMIN_AND_MANAGERS, VENDOR, ALL_STAFF, ALL_STAFF_NO_AM, ADMIN_AND_PROJECT_MANAGER, ADMIN_AND_MANAGERS_NO_AM, ADMIN_AND_MANAGERS_NO_PM_AM } from "./utils/constants/roles";
import { useContext } from "react";
import { AuthContext } from "./context/AuthContext";

const JobsPageRouter = () => {
  const { user } = useContext(AuthContext);
  if (user?.roleSlug === "vendor") return <VendorJobsPage />;
  return <JobsPage />;
};

const VendorInvoicesRouter = () => {
  const { user } = useContext(AuthContext);
  if (user?.roleSlug === "vendor") return <VendorInvoicesPage />;
  return <AdminVendorInvoicesPage />;
};

const VendorInvoiceDetailRouter = () => {
  const { user } = useContext(AuthContext);
  if (user?.roleSlug === "vendor") return <VendorInvoiceDetailPage />;
  return <AdminVendorInvoiceDetailPage />;
};

const VendorPaymentsRouter = () => {
  const { user } = useContext(AuthContext);
  if (user?.roleSlug === "vendor") return <VendorPaymentsPage />;
  return <AdminVendorPaymentsPage />;
};

const VendorPaymentDetailRouter = () => {
  const { user } = useContext(AuthContext);
  if (user?.roleSlug === "vendor") return <VendorPaymentDetailPage />;
  return <AdminVendorPaymentDetailPage />;
};

const App = () => (
  <AuthProvider>
    <ToastProvider>
    <Router>
      <Routes>  
        <Route path="/" element={<HomePage />} />
        <Route path="/create-account" element={<AdminRegisteration />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/account-activation/:token" element={<AccountActivation />} />
        <Route path="/vendor/activate/:token" element={<VendorActivation />} />
        <Route path="/apply/vendor/:token" element={<VendorApplicationFormPage />} />
        <Route path="/manager/activate/:token" element={<ManagerActivation />} />
        <Route path="/request-reset" element={<RequestReset />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route element={<MainLayout />}>
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={ALL_STAFF}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/setup"
          element={
            <ProtectedRoute allowedRoles={ADMIN}>
              <SetupWizardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute allowedRoles={ALL_STAFF}>
              <ProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <ProtectedRoute allowedRoles={ALL_STAFF}>
              <ChangePassword />
            </ProtectedRoute>
          }
        />
        <Route
          path="managers/create-manager"
          element={
            <ProtectedRoute allowedRoles={ADMIN} enterpriseOnly>
              <CreateManager />
            </ProtectedRoute>
          }
        />
        <Route
          path="/managers"
          element={
            <ProtectedRoute allowedRoles={ADMIN} enterpriseOnly>
              <ManagersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="managers/:id"
          element={
            <ProtectedRoute allowedRoles={ADMIN} enterpriseOnly>
              <ManagerDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="clients/create-client"
          element={
            <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}>
              <CreateClientPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/clients"
          element={
            <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS}>
              <ClientsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/clients/price-list"
          element={
            <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS}>
              <MasterPriceListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="clients/:id"
          element={
            <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS}>
              <ClientDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client-pools"
          element={
            <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_PM_AM} enterpriseOnly>
              <ClientPoolsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-client-pool"
          element={
            <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_PM_AM} enterpriseOnly>
              <AddClientPoolPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="client-pools/:id"
          element={
            <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_PM_AM} enterpriseOnly>
              <ClientPoolDetailsPage />
            </ProtectedRoute>
          }
        />
          <Route
            path="system-values/services"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_PROJECT_MANAGER}>
                <ServicesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="system-values/language-pairs"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_PROJECT_MANAGER}>
                <LanguagePairsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="system-values/specializations"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_PROJECT_MANAGER}>
                <SpecializationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="system-values/units"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_PROJECT_MANAGER}>
                <UnitPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="system-values/currencies"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_PROJECT_MANAGER}>
                <CurrencyPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="system-values/payment-methods"
            element={
              <ProtectedRoute allowedRoles={ADMIN}>
                <PaymentMethodPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="system-values"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_PROJECT_MANAGER}>
                <SystemValuesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="vendors/create-vendor"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_PM_AM} enterpriseOnly>
                <CreateVendorPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendors"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS} enterpriseOnly>
                <VendorsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendors/price-list"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS} enterpriseOnly>
                <VendorMasterPriceListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendors/:id"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS} enterpriseOnly>
                <VendorDetailPage />
              </ProtectedRoute>
            }
          />
          {/* Quotations carry the same access as projects. */}
          <Route path="/quotations" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><QuotationsPage /></ProtectedRoute>} />
          <Route path="/quotations/create-quotation" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><CreateQuotationPage /></ProtectedRoute>} />
          <Route path="/quotation/:id" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><QuotationDetailPage /></ProtectedRoute>} />
          <Route path="/quotation/edit/:id" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><EditQuotationPage /></ProtectedRoute>} />
          <Route path="/quotation/:id/new-receivable" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><QuotationReceivablePage /></ProtectedRoute>} />
          <Route path="/quotation/:id/receivable/:receivableId/edit" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><QuotationReceivablePage /></ProtectedRoute>} />

          <Route
            path="/projects"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}>
                <ProjectsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/create-project"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}>
                <CreateProjectPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project/:id"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}>
                <ProjectDetailPage />
              </ProtectedRoute>
            }
          />

          <Route path="/project/edit/:id" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><EditProjectDetails /></ProtectedRoute>} />
          
          <Route path="/project/:id/new-flat-rate-receivable" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><CreateFlatRateReceivablePage /></ProtectedRoute>} />
          <Route path="/project/:id/new-unit-based-receivable" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><CreateUnitBasedReceivablePage /></ProtectedRoute>} />
          {/* <Route path="/project/:id/new-cat-log" element={<CreateCATLogPage />} /> */}
          <Route path="/project/:id/edit-flat-rate-receivable/:receivableId" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><EditFlatRateReceivable /></ProtectedRoute>} />
          <Route path="/project/:id/edit-unit-based-receivable/:receivableId" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><EditUnitBasedReceivablePage /></ProtectedRoute>} />


          <Route path="/project/:id/job/:jobId/new-flat-rate-receivable" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM} enterpriseOnly><CreateFlatRatePayablePage /></ProtectedRoute>} />
          <Route path="/project/:id/job/:jobId/new-unit-based-receivable" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM} enterpriseOnly><UnitBasedPayablePage /></ProtectedRoute>} />
          {/* <Route path="/project/:id/job/:jobId/:id/new-cat-log" element={<CreateCATLogPage />} /> */}
          <Route path="/project/:id/job/:jobId/edit-flat-rate-receivable/:payableId" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM} enterpriseOnly><EditFlatRatePayable /></ProtectedRoute>} />
          <Route path="/project/:id/job/:jobId/edit-unit-based-receivable/:payableId" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM} enterpriseOnly><EditUnitBasedPayablePage /></ProtectedRoute>} />


          <Route
            path="/client/receivables"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS}>
                <ReceivablesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/receivable/:id"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS}>
                <ReceivableDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendor/payables"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS} enterpriseOnly>
                <PayablesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendor/payable/:id"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS} enterpriseOnly>
                <PayableDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/receivable/:id/adjustments"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS}>
                <AdjustmentsPage resource="receivable" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendor/payable/:id/adjustments"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS} enterpriseOnly>
                <AdjustmentsPage resource="payable" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/invoice/:id/adjustments"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS}>
                <AdjustmentsPage resource="client-invoice" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendor/invoice/:id/adjustments"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS} enterpriseOnly>
                <AdjustmentsPage resource="vendor-invoice" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/invoice/:id/write-off"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS}>
                <WriteOffPage resource="client-invoice" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vendor/invoice/:id/write-off"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS} enterpriseOnly>
                <WriteOffPage resource="vendor-invoice" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/invoices"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS}>
                <ClientInvoicesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/invoice/:id"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS}>
                <ClientInvoiceDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/payments"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS}>
                <ClientPaymentsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/payments/new"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS}>
                <NewPaymentPage party="client" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client/payment/:id"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS}>
                <ClientPaymentDetailPage />
              </ProtectedRoute>
            }
          />

          <Route path="/project/:id/create-job" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM} enterpriseOnly><CreateJobsPage /></ProtectedRoute>} />

           <Route
            path="/jobs"
            element={
              <ProtectedRoute allowedRoles={ALL_STAFF_NO_AM} enterpriseOnly>
                <JobsPageRouter />
              </ProtectedRoute>
            }
          />

          <Route
            path="/project/:id/job/:jobId"
            element={
              <ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM} enterpriseOnly>
                <JobDetailPage />
              </ProtectedRoute>
            }
          />

          <Route path="/project/:id/job/:jobId/edit" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM} enterpriseOnly><EditJobPage /></ProtectedRoute>} />

          <Route path="/vendor/tenders" element={<ProtectedRoute allowedRoles={VENDOR}><VendorTendersPage /></ProtectedRoute>} />
          <Route path="/vendor/agreement" element={<ProtectedRoute allowedRoles={VENDOR}><VendorAgreementPage /></ProtectedRoute>} />
          <Route path="/vendor/job/:jobId" element={<ProtectedRoute allowedRoles={VENDOR}><VendorJobDetailPage /></ProtectedRoute>} />
          <Route path="/vendor/receivables" element={<ProtectedRoute allowedRoles={VENDOR}><VendorReceivablesPage /></ProtectedRoute>} />
          <Route path="/vendor/receivable/:id" element={<ProtectedRoute allowedRoles={VENDOR}><VendorReceivableDetailPage /></ProtectedRoute>} />
          <Route path="/vendor/invoices" element={<ProtectedRoute allowedRoles={ALL_STAFF} enterpriseOnly><VendorInvoicesRouter /></ProtectedRoute>} />
          <Route path="/vendor/invoice/:id" element={<ProtectedRoute allowedRoles={ALL_STAFF} enterpriseOnly><VendorInvoiceDetailRouter /></ProtectedRoute>} />
          <Route path="/vendor/payments" element={<ProtectedRoute allowedRoles={ALL_STAFF} enterpriseOnly><VendorPaymentsRouter /></ProtectedRoute>} />
          <Route path="/vendor/payments/new" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS} enterpriseOnly><NewPaymentPage party="vendor" /></ProtectedRoute>} />
          <Route path="/vendor/payment/:id" element={<ProtectedRoute allowedRoles={ALL_STAFF} enterpriseOnly><VendorPaymentDetailRouter /></ProtectedRoute>} />

          {/* Freelance-only: Files module */}
          <Route path="/files" element={<ProtectedRoute allowedRoles={ADMIN}><FilesPage /></ProtectedRoute>} />
          <Route path="/finances" element={<ProtectedRoute allowedRoles={ADMIN} freelanceOnly><FinancesPage /></ProtectedRoute>} />

          {/* Vendor manager portal */}
          <Route path="/todos" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><ToDosPage /></ProtectedRoute>} />
          <Route path="/vendor/applications" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_PM_AM} enterpriseOnly><VendorApplicationsPage /></ProtectedRoute>} />
          <Route path="/vendor/contacts" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM} enterpriseOnly><VendorContactsPage /></ProtectedRoute>} />
          <Route path="/vendor/prices" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM} enterpriseOnly><VendorPricesPage /></ProtectedRoute>} />
          <Route path="/vendor/tags" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM} enterpriseOnly><VendorTagsPage /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute allowedRoles={ADMIN}><SettingsPage /></ProtectedRoute>} />
          <Route path="/settings/account" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><AccountPage /></ProtectedRoute>} />
          <Route path="/settings/license" element={<ProtectedRoute allowedRoles={ADMIN}><PlaceholderPage title="License" description="License details will be shown here." /></ProtectedRoute>} />
          <Route path="/settings/object-codes" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><ObjectCodesPage /></ProtectedRoute>} />
          <Route path="/settings/legal-entities" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><PlaceholderPage title="Legal Entities" description="Legal entities will be managed here." /></ProtectedRoute>} />
          <Route path="/settings/roles" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM} enterpriseOnly><PlaceholderPage title="Roles" description="Roles will be managed here." /></ProtectedRoute>} />
          <Route path="/settings/taxes/client-default" element={<ProtectedRoute allowedRoles={ADMIN}><DefaultTaxesPage key="client" party="client" title="Default Taxes for Clients" /></ProtectedRoute>} />
          <Route path="/settings/taxes/vendor-default" element={<ProtectedRoute allowedRoles={ADMIN} enterpriseOnly><DefaultTaxesPage key="vendor" party="vendor" title="Default Taxes for Vendors" /></ProtectedRoute>} />
          <Route path="/settings/reminders" element={<ProtectedRoute allowedRoles={ADMIN}><RemindersPage /></ProtectedRoute>} />
          <Route path="/settings/smtp-server" element={<ProtectedRoute allowedRoles={ADMIN}><SmtpServerPage /></ProtectedRoute>} />
          <Route path="/settings/client-portal" element={<ProtectedRoute allowedRoles={ADMIN}><PlaceholderPage title="Client Portal" description="Client portal settings will be managed here." /></ProtectedRoute>} />
          <Route path="/settings/email-templates/quote" element={<ProtectedRoute allowedRoles={ADMIN}><PlaceholderPage title="Quote Email Template" description="The quote email template will be edited here." /></ProtectedRoute>} />
          <Route path="/settings/email-templates/multi-quote" element={<ProtectedRoute allowedRoles={ADMIN}><PlaceholderPage title="Multi-Quote Email Template" description="The multi-quote email template will be edited here." /></ProtectedRoute>} />
          <Route path="/settings/email-templates/client-invoice" element={<ProtectedRoute allowedRoles={ADMIN}><PlaceholderPage title="Client Invoice Email Template" description="The client invoice email template will be edited here." /></ProtectedRoute>} />
          <Route path="/settings/pdf-templates/images" element={<ProtectedRoute allowedRoles={ADMIN}><PlaceholderPage title="PDF Images" description="Logos and images used in PDFs will be managed here." /></ProtectedRoute>} />
          <Route path="/settings/pdf-templates/client-invoice" element={<ProtectedRoute allowedRoles={ADMIN}><PlaceholderPage title="Client Invoice PDF Template" description="The client invoice PDF template will be edited here." /></ProtectedRoute>} />
          <Route path="/settings/pdf-templates/vendor-invoice" element={<ProtectedRoute allowedRoles={ADMIN} enterpriseOnly><PlaceholderPage title="Vendor Invoice PDF Template" description="The vendor invoice PDF template will be edited here." /></ProtectedRoute>} />
          <Route path="/settings/pdf-templates/quote" element={<ProtectedRoute allowedRoles={ADMIN}><PlaceholderPage title="Quote PDF Template" description="The quote PDF template will be edited here." /></ProtectedRoute>} />
          <Route path="/settings/pdf-templates/job-po" element={<ProtectedRoute allowedRoles={ADMIN} enterpriseOnly><PlaceholderPage title="Job PO PDF Template" description="The job purchase order PDF template will be edited here." /></ProtectedRoute>} />
          <Route path="/settings/managers" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><PlaceholderPage title="Managers" description="Managers will be managed here." /></ProtectedRoute>} />
          <Route path="/settings/system-values/language-pairs" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><SystemValuesLanguagePairsPage /></ProtectedRoute>} />
          <Route path="/settings/system-values/services" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><SystemValuesServicesPage /></ProtectedRoute>} />
          <Route path="/settings/system-values/specializations" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><SystemValuesSpecializationsPage /></ProtectedRoute>} />
          <Route path="/settings/system-values/units" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><PlaceholderPage title="Units" description="Units will be managed here." /></ProtectedRoute>} />
          <Route path="/settings/system-values/currencies" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><PlaceholderPage title="Currencies" description="Currencies will be managed here." /></ProtectedRoute>} />
          <Route path="/settings/taxes" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM}><TaxesPage /></ProtectedRoute>} />
          <Route path="/settings/vendor-portal" element={<ProtectedRoute allowedRoles={ADMIN_AND_MANAGERS_NO_AM} enterpriseOnly><VendorPortalPage /></ProtectedRoute>} />

          </Route>
      </Routes>
    </Router>
    </ToastProvider>
  </AuthProvider>
);

export default App;